export default "__VITE_ASSET__CxJM4yAK__"